import * as React from "react"
import {
  Create,
} from "react-admin"
import CategoryForm from "./CategoryForm"

const CategoryTitle = () => {
  return <span>{'商品系列'}</span>;
};

const CategoryCreate = () => {
  return (
    <Create 
      title={<CategoryTitle/>}
    >
      <CategoryForm 
        formType="create"
      />
    </Create>
  )
}

export default CategoryCreate